"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../_util/useConfig"));
var Title = function (props) {
    var _a;
    // 解析props属性
    var flexTitle = props.flexTitle, mergeComponentStatus = props.mergeComponentStatus, desc = props.desc, className = props.className, style = props.style, _b = props.buyType, buyType = _b === void 0 ? '' : _b, flexSmallTitle = props.flexSmallTitle;
    var isShowDesc = desc && desc !== '<p></p>'; // 过滤富文本空字符
    // 获取样式的通用前缀
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var preClassName = "".concat(classPrefix, "-title");
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, preClassName), style: style || {} },
        react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(preClassName, "__container"), (_a = {},
                _a["".concat(preClassName, "__not_title")] = !flexTitle,
                _a["".concat(preClassName, "__not_title--mr")] = mergeComponentStatus,
                _a["".concat(preClassName, "__small_title--add")] = flexSmallTitle,
                _a), className) },
            react_1.default.createElement("span", { className: (0, classnames_1.default)('flex-title', {
                    'aduiovb-theme': ['audiovb'].includes(buyType),
                }) }, flexTitle),
            isShowDesc && (react_1.default.createElement("span", { className: "flex-title__desc", dangerouslySetInnerHTML: { __html: desc || '' } })),
            flexSmallTitle && react_1.default.createElement("div", { className: "flex-small-title" }, flexSmallTitle))));
};
Title.displayName = 'Title';
exports.default = Title;
//# sourceMappingURL=FlexTitle.js.map